import { z } from "zod";

export const newAssetSchema = z
  .object({
    files: z.instanceof(File).array().min(1),
    config: z.any().optional(),
    config_id: z
      .string()
      .optional()
      .transform((config_id) => config_id || undefined),
    name: z
      .string()
      .optional()
      .transform((name) => name || undefined),
    workspace_id: z.string().nullable(),
  })
  .refine((newAsset) => !!newAsset.config !== !!newAsset.config_id);

export type NewAssetForm = z.infer<typeof newAssetSchema>;
